import {Box, Typography} from "@mui/material";

import ResponsiveAppBar from "../assets/components/ResponsiveAppBar.tsx";
import Footer from "./Footer.tsx";
import CareerForm from "../assets/components/CareerForm.tsx";

function Careers() {
    return (
        <>
                <ResponsiveAppBar/>
                <Box className={'tile'} sx={{mb:20,}}>
                    <br/>
                    <Typography variant={"h4"}>Looking to join our team? Apply below.</Typography>
                    <Box sx={{display:'flex', justifyContent:'center', flexDirection:{xs: 'column-reverse', md:'row',} }}>
                        <Box sx={{mr:{md:5, xs:0}, mt:5,}}>
                            <CareerForm/>
                        </Box>
                    </Box>
                </Box>
                <Footer/>
        </>
    );
}

export default Careers
